module.exports = __webpack_public_path__ + "s/img/Power_M_5.82e93a90.jpg";